import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import queryString from "query-string";
import {withRouter} from "react-router";
import $ from "jquery";
import InternalClaim from "./InternalClaim";

class Claim extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            settings: null,
            isDataReady: false,
        }
    }

    componentDidMount() {
        const query = queryString.parse(this.props.location.search);
        const withoutCreate = Object.assign({}, query);
        delete withoutCreate["Create"];

        this.props.history.replace(this.props.location.pathname + '?' + queryString.stringify(withoutCreate) + this.getHash(this.props.location.hash));
        this.initialize();
    }

    getHash = (hash) => {
        try {
            return $(hash) ? hash : '';
        } catch (e) {
            console.error(e);
            return '';
        }
    }
    initialize = async () => {
        try {
            if (this.props.TypeClaimViewIntId) {
                await this.props.dispatch(this.props.ClaimPers_GetDefViewPO.execute({TypeClaimViewIntId: this.props.TypeClaimViewIntId}));
                if (!this.props.ClaimPers_GetDefViewPO.isError) {
                    const row = this.props.ClaimPers_GetDefViewPO.getRow(0);
                    this.setState({settings: row});
                }
            }
        } finally {
            this.setState({isDataReady: true});
        }
    }


    render() {
        if (!this.state.isDataReady)
            return null;
        return (<InternalClaim settings={this.state.settings} {...this.props} />);
    }
}

Claim.propTypes = {
    dispatch: PropTypes.func.isRequired,
    TypeClaimViewIntId: PropTypes.number,
    ClaimPers_GetDefViewPO: PropTypes.object
};
Claim.defaultProps = {
    TypeClaimViewIntId: 1
};

function mapStateToProps(state, ownProps) {
    return {
        ClaimPers_GetDefViewPO: state.claimState.ClaimPers_GetDefViewPO
    }
}

export default withRouter(connect(mapStateToProps)(Claim));